import styled from 'styled-components';
import * as Semantic from 'semantic-ui-react';

const Container = styled(Semantic.Container)`
  padding-top: 40px;
`;

const ContainerContent = styled.div`
  margin-bottom: 40px;
`;

export {
  Container,
  ContainerContent,
};
